var map = {
	"./buy_super_cn.png": 28809,
	"./buy_super_en.png": 67723,
	"./buy_super_id.png": 46909,
	"./buy_super_ko.png": 92568,
	"./buy_super_ph.png": 38478,
	"./buy_super_th.png": 26818,
	"./buy_super_zh.png": 29500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11607;